import { Box, Divider, Flex, Grid, GridItem, Show } from '@chakra-ui/react';
import { checkHasIndustry } from './utils';
import Details from './Details';
import SummaryNav from './SummaryNav';

const SummaryBox = ({ props, formikProps, secOrIndIndex, styles }) => {
  const jobSeekerDataInd = formikProps.values.jobSeekerData[secOrIndIndex];
  const sectionName = props.stateProps.sectionData.sectionName;
  let hasIndustry = checkHasIndustry(
    sectionName,
    jobSeekerDataInd['industry'],
    jobSeekerDataInd['job_title']
  );

  return (
    <>
      <Show breakpoint="(min-width: 768px)">
        <Box sx={{ ...styles.summary.mainwrapper }}>
          <Grid templateColumns="repeat(10, 1fr)" gap={0}>
            <GridItem sx={{ display: 'flex', alignItems: 'center'}} colSpan={5}>
              <Details styles={styles} sections={props.sections} values={props.formikProps.values} secOrIndIndex={secOrIndIndex} />
            </GridItem>
            <GridItem colSpan={3}>
              {/*hasIndustry && PersonalizationChart(props, jobSeekerDataInd)*/}
            </GridItem>
            <GridItem colSpan={2}>
              <SummaryNav props={props} secOrIndIndex={secOrIndIndex}/>
            </GridItem>
          </Grid>
        </Box>
      </Show>

      <Show breakpoint="(max-width: 767px)">
        <Box sx={{ ...styles.summary.mainwrapper }}>
          <Flex justifyContent={'space-between'}>
            <Details styles={styles} sections={props.sections} values={props.formikProps.values} secOrIndIndex={secOrIndIndex} />
            <SummaryNav props={props} secOrIndIndex={secOrIndIndex} />
          </Flex>

          {hasIndustry && (
            <>
              <Divider pt={1} />
              <Box sx={{ ...styles.summary.subwrapper }}>
                {/*PersonalizationChart(props, jobSeekerDataInd)*/}
              </Box>
            </>
          )}
        </Box>
      </Show>
    </>
  );
};

export default SummaryBox;
